/**
 * @flow
 * @relayHash 7b6903d7d3f190fcbd3e54ca58605815
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type importLogsQueryVariables = {|
  propertyId: string
|};
export type importLogsQueryResponse = {|
  +importLogs: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +createdAt: any,
        +fileName: string,
        +importedAt: ?any,
        +importedBy: string,
        +totalRows: number,
        +successCount: number,
        +failureCount: number,
        +contactsBeforeLoad: number,
        +contactsAfterLoad: number,
      |}
    |}>
  |}
|};
export type importLogsQuery = {|
  variables: importLogsQueryVariables,
  response: importLogsQueryResponse,
|};
*/


/*
query importLogsQuery(
  $propertyId: ID!
) {
  importLogs(propertyId: $propertyId) {
    edges {
      node {
        id
        createdAt
        fileName
        importedAt
        importedBy
        totalRows
        successCount
        failureCount
        contactsBeforeLoad
        contactsAfterLoad
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "propertyId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "importLogs",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "propertyId",
        "variableName": "propertyId"
      }
    ],
    "concreteType": "ImportLogConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ImportLogEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "ImportLog",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "fileName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "importedAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "importedBy",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalRows",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "successCount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "failureCount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "contactsBeforeLoad",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "contactsAfterLoad",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "importLogsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "importLogsQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "importLogsQuery",
    "id": null,
    "text": "query importLogsQuery(\n  $propertyId: ID!\n) {\n  importLogs(propertyId: $propertyId) {\n    edges {\n      node {\n        id\n        createdAt\n        fileName\n        importedAt\n        importedBy\n        totalRows\n        successCount\n        failureCount\n        contactsBeforeLoad\n        contactsAfterLoad\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '87a094df54beb76fcb6e55aa5a991a29';
module.exports = node;
